// extracted by mini-css-extract-plugin
export default {"root":"Tools_root__WTQrD","form":"Tools_form__hRmg2","course":"Tools_course__LmpPg","search":"Tools_search__PACdT","select":"Tools_select__Ns5Pi"};